const  IconArrowSelect= () => {

    return (

        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 4C1.8 4.4 4.66667 7.5 6 9L11 4" stroke="#405363"/>
        </svg>
    )

}

export default IconArrowSelect;
